import React from "react";
import Modal from "components/common/Modal";

interface IMergeCellsPopUpModalProps {
    onClose(): void;
}

const MergeCellsPopUpModal: React.FC<IMergeCellsPopUpModalProps> = (props) => {
    return (
        <Modal header={"Merging Cells"}
            isOpen={true}
            controls={
                <button
                    className="secondary-button"
                    onClick={() => {
                        props.onClose();
                    }}
                >
                    Ok
                </button>
            }
        >
            <p>Merging cells only keeps the upper-left value and discards other values.</p>
        </Modal>
    )
}

export default MergeCellsPopUpModal;